import { tsValidate, tsValidateArray, tsValidateBoolean, tsValidateDynamicObject, tsValidateExists, tsValidateNonMandatoryObject, tsValidateOptionalId, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { DBDef_FHIRQuery } from '@app/fhir-shared';
import { DBDef_NLPModel } from '../nlp-model/db-def.js';
const Validator_QueryData = {
    resourceType: tsValidateString(),
    params: tsValidateDynamicObject(tsValidateString(), tsValidateString()),
};
const Validator_FormVariable = (instance) => {
    const validationError = tsValidate(instance, tsValidateExists());
    if (validationError)
        return validationError;
    return tsValidate(instance, {
        id: tsValidateUniqueId,
        isCommon: tsValidateBoolean(false),
        attributes: tsValidateArray(Validator_FormVariable, false),
        defaultValueId: tsValidateOptionalId,
    });
};
const Validator_Config = {
    produceChiefComplaint: tsValidateBoolean(),
    showChiefComplaints: tsValidateBoolean(),
    onlyChiefComplaints: tsValidateBoolean(),
};
const Validator_ModifiableProps = {
    label: tsValidateString(),
    contextRuleId: tsValidateUniqueId,
    defaultText: tsValidateString(-1, false),
    renderedLabel: tsValidateString(-1, false),
    formVariables: tsValidateArray(Validator_FormVariable, false),
    queryData: tsValidateNonMandatoryObject(Validator_QueryData),
    fhirQueryIds: tsValidateArray(tsValidateUniqueId, false),
    nlpModelId: tsValidateOptionalId,
    config: Validator_Config,
    allowAISuggestions: tsValidateBoolean(false),
};
const Validator_GeneratedProps = {
    __variableIds: tsValidateArray(tsValidateUniqueId),
};
export const DBDef_AdvisorSnippet = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.9', '1.0.8', '1.0.7', '1.0.6', '1.0.5'],
    dbKey: 'advisor-context',
    entityName: 'advisor-context',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'advisor-snippet'
    },
    backend: {
        name: 'advisor-context'
    },
    dependencies: {
        __variableIds: { dbKey: 'variables', fieldType: 'string[]' },
        contextRuleId: { dbKey: 'context-rule', fieldType: 'string' },
        fhirQueryIds: { dbKey: DBDef_FHIRQuery.dbKey, fieldType: 'string[]' },
        nlpModelId: { dbKey: DBDef_NLPModel.dbKey, fieldType: 'string' }
    }
};
//# sourceMappingURL=db-def.js.map